'use client';

import Image from 'next/image';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';

interface ImageCompareProps {
  before: string;
  after: string;
  beforeLabel?: string;
  afterLabel?: string;
  alt: string;
  width?: number;
  height?: number;
}

function getImageUrl(src: string | undefined): string {
  if (!src) return '';
  const bucket = src.startsWith('photo-gallery/') ? 'photo-gallery' : 'blog-images';
  const storagePath = bucket === 'photo-gallery'
    ? src.replace('photo-gallery/', '')
    : src;
  const baseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
  return `${baseUrl}/storage/v1/object/public/${bucket}/${storagePath}`;
}

export function ImageCompare({
  before,
  after,
  beforeLabel = 'Před',
  afterLabel = 'Po',
  alt,
}: ImageCompareProps) {
  const beforeUrl = getImageUrl(before);
  const afterUrl = getImageUrl(after);

  return (
    <div className="relative w-full overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700">
      <ReactCompareSlider
        itemOne={
          <ReactCompareSliderImage src={beforeUrl} alt={`${alt} - ${beforeLabel}`} />
        }
        itemTwo={
          <ReactCompareSliderImage src={afterUrl} alt={`${alt} - ${afterLabel}`} />
        }
        handle={
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-white shadow-lg border border-gray-200 cursor-ew-resize">
            <svg className="w-5 h-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l-3 3 3 3M16 9l3 3-3 3" />
            </svg>
          </div>
        }
      />
      <div className="absolute bottom-3 left-4 bg-black/50 text-white text-xs px-2 py-1 rounded pointer-events-none">
        {beforeLabel}
      </div>
      <div className="absolute bottom-3 right-4 bg-black/50 text-white text-xs px-2 py-1 rounded pointer-events-none">
        {afterLabel}
      </div>
    </div>
  );
}
